// extracted by mini-css-extract-plugin
export default {"root":"Sidebar-root","showing":"Sidebar-showing"};